import { render, staticRenderFns } from "./validacion-correo.vue?vue&type=template&id=a6552afa&scoped=true"
import script from "./validacion-correo.vue?vue&type=script&lang=js"
export * from "./validacion-correo.vue?vue&type=script&lang=js"
import style0 from "./validacion-correo.vue?vue&type=style&index=0&id=a6552afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6552afa",
  null
  
)

export default component.exports